"use client";

import { useEffect, useState } from "react";

/**
 * 처음 온 사람에게 "여기가 어딘지" 한 줄.
 *
 * 왜 필요한가 (2026-08-08 첫 화면 검수): 로그인 안 한 새 브라우저로 들어와 보니 첫 화면
 * 전체 글자가 **192자**였고 대부분 분류 이름이었다. **핫플이 무엇인지 한 줄이 없다.**
 * 릴스를 보고 넘어온 사람은 우리를 모르는데, 음식 사진 격자만 보고 "예쁜 사진 모음인가"
 * 하고 나간다.
 *
 * 규칙 세 가지.
 *   · **한 번만** 보여 준다. 닫으면 다시 안 뜬다(브라우저에 기억).
 *   · **로그인한 사람에게는 안 뜬다.** 이미 아는 사람에게 설명할 이유가 없다.
 *   · 피드를 가리지 않는다 — 분류 탭 아래 한 줄로 눕는다.
 *
 * ⚠️ 서버에서 그리면 안 된다. 처음인지 아닌지는 그 사람 브라우저만 알고 있고,
 *    서버가 미리 그려 두면 이미 닫은 사람에게도 잠깐 보였다 사라진다.
 */
const STORAGE_KEY = "hotple:first-visit-band-dismissed";

const FirstVisitBand = ({ isLoggedIn = false }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isLoggedIn) return;
    try {
      if (window.localStorage.getItem(STORAGE_KEY) === "1") return;
    } catch {
      // 브라우저가 저장을 막아 두었으면(사생활 보호 모드 등) 그냥 보여 준다.
    }
    setVisible(true);
  }, [isLoggedIn]);

  const dismiss = () => {
    setVisible(false);
    try {
      window.localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      // 기억하지 못해도 화면은 닫힌다.
    }
  };

  if (!visible) return null;

  return (
    <div className="flex w-full items-center gap-3 border-b border-black/5 bg-white px-4 py-3 dark:border-white/10 dark:bg-neutral-900">
      <p className="min-w-0 flex-1 text-[14px] font-bold leading-snug text-black dark:text-white">
        가볼 만한 곳, 영상으로 먼저 보세요
      </p>
      <button
        type="button"
        aria-label="안내 닫기"
        onClick={dismiss}
        className="shrink-0 px-1 text-[17px] leading-none text-black/35 transition active:scale-90 dark:text-white/40"
      >
        ✕
      </button>
    </div>
  );
};

export default FirstVisitBand;
